<ng-template #locationTmpl let-location="location" let-tripType="tripType">
  <p>
    <span *ngIf="displayAirportName"> {{ location.originLocationCode | finLocationName }} </span>
    <span [ngClass]="stylesMap[mode].textSize">{{ location.originLocationCode }}</span>
    <span class="flex--nogrow ps-xxsmall-x">
      <fcom-icon
        *ngIf="tripType === TripType.RETURN"
        class="icon-small"
        name="return-trip"
        [informative]="true"
      ></fcom-icon>
      <fcom-icon
        *ngIf="tripType === TripType.ONEWAY"
        class="icon-small"
        name="aircraft-horizontal"
        [informative]="true"
      ></fcom-icon>
      <fcom-icon
        *ngIf="tripType === TripType.MULTICITY"
        class="icon-small"
        name="aircraft-horizontal"
        [informative]="true"
      ></fcom-icon>
    </span>
    <span *ngIf="displayAirportName">
      {{ location.destinationLocationCode | finLocationName }}
    </span>
    <span [ngClass]="stylesMap[mode].textSize" [class.ps-small-r]="tripType !== TripType.MULTICITY">{{
      location.destinationLocationCode
    }}</span>
  </p>
</ng-template>

<div [ngClass]="[stylesMap[mode].backgroundColor, stylesMap[mode].spacing]">
  <div class="relative">
    <div
      data-id="status-bar-location-container"
      class="col-1-12 overflow-hidden"
      [ngClass]="[stylesMap[mode].display, stylesMap[mode].textColor]"
    >
      <ng-container *ngIf="tripType === TripType.RETURN; else oneWayOrMultiCity">
        <ng-container
          [ngTemplateOutlet]="locationTmpl"
          [ngTemplateOutletContext]="{ location: locations[0], tripType: tripType }"
        ></ng-container>
      </ng-container>
      <ng-template #oneWayOrMultiCity>
        <ng-container *ngFor="let location of locations; let last = last">
          <ng-container
            [ngTemplateOutlet]="locationTmpl"
            [ngTemplateOutletContext]="{ location: location, tripType: tripType }"
          >
          </ng-container>
          <div *ngIf="tripType === TripType.MULTICITY" [ngClass]="{ 'ps-small-r': last, 'ps-xxsmall-r': !last }">
            <span *ngIf="!last && !displayAirportName">, </span>
          </div>
        </ng-container>
      </ng-template>

      <span class="medium-type font-body-1 ps-small-r" *ngIf="dates.returnDate">
        {{ dates.departureDate | finDateFormat: 'DATE' }} -
        {{ dates.returnDate | finDateFormat: 'DATE' }}
      </span>
      <span class="medium-type font-body-1 ps-small-r" *ngIf="!dates.returnDate">
        {{ dates.departureDate | finDateFormat: 'DATE' }}
      </span>
      <span class="medium-type font-body-1" *ngIf="paxAmount">
        <fcom-icon class="icon-small" name="adult-infant" [informative]="true"></fcom-icon>
        {{ paxAmount }}
      </span>
    </div>
  </div>
</div>
